(function () {
  var tabList = $(".tablist");

  // Enable arrow navigation between tabs in the tab list

  tabList.each(function () {
    var tabs = $(this).find(".tab-button");

    // Add a click event handler to each tab

    tabs.each(function () {
      $(this).click(function (e) {
        var target = $(e.target);
        var parent = target.closest(".tablist");
        var grandparent = parent.closest(".tabs");

        // Remove all current selected tabs

        parent.find('[aria-selected="true"]').each(function () {
          $(this).attr("aria-selected", false);
        });

        // Set this tab as selected

        target.attr("aria-selected", true);

        // Hide all tab panels

        grandparent.find(".tab-panel").each(function () {
          $(this).attr("hidden", true);
        });

        // Show the selected panel

        grandparent
          .parent()
          .find("#" + target.attr("aria-controls"))
          .attr("hidden", false);
        let left = target.position().left;
        let width = target.outerWidth();
        let indicatorWidth = $(".tab-indicator").outerWidth();
        let position = width / 2 + left - indicatorWidth / 2;
        $(".tab-indicator").css("left", position);
      });
    });

    var tabFocus = 0;
    $(this).on("keydown", (e) => {
      // Move right

      if (e.keyCode === 39 || e.keyCode === 37) {
        $(tabs[tabFocus]).attr("tabindex", -1);
        if (e.keyCode === 39) {
          tabFocus++;

          // If we're at the end, go to the start

          if (tabFocus >= tabs.length) {
            tabFocus = 0;
          }

          // Move left
        } else if (e.keyCode === 37) {
          tabFocus--;

          // If we're at the start, move to the end

          if (tabFocus < 0) {
            tabFocus = tabs.length - 1;
          }
        }

        $(tabs[tabFocus]).attr("tabindex", 0);
        $(tabs[tabFocus]).focus();
      }
    });

    $(this).on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        var tab = $(this).find(".slick-slide").eq(nextSlide);
        var tabs = $(this).find(".tab-button");
        tabs.attr("tabindex", -1);
        tab.click();
        setTimeout(function () {
          tab.focus();
          tab.attr("tabindex", 0);
        }, 500);
      }
    );
    var $status = $(".slider-counter");
    $(this).on(
      "init reInit afterChange",
      function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        // use dots to get some count information
        if (slick && slick.$dots && slick.$dots[0] && slick.$dots[0].children) {
          $status.text(i + " / " + slick.$dots[0].children.length);
        }
      }
    );
  });

  $(window).on("load resize orientationchange", function () {
    var carouselContainerTabs = $(".js-tabs-global");
    carouselContainerTabs.each(function () {
      var carousel = $(this).find(".tablist");
      if (window.innerWidth < 768) {
        if (!carousel.hasClass("slick-initialized")) {
          carousel.slick({
            variableWidth: true,
            prevArrow: $(this).find(".slider-arrow-prev"),
            nextArrow: $(this).find(".slider-arrow-next"),
            infinite: false,
            accessibility: true,
            mobileFirst: true,
            dots: true,
            focusOnSelect: true,
            focusOnChange: true,
            appendDots: $(this).find(".slider-counter"),
            touchThreshold: 100,
            useTransform: false,
            outerEdgeLimit: true,
          });
        }
      } else {
        if (carousel.hasClass("slick-initialized")) {
          carousel.slick("unslick");
        }
      }
    });
  });
})();
